import type { GetSubscriptions200SubscriptionsItem } from './getSubscriptions200SubscriptionsItem';

export type GetSubscriptions200 = {
  subscriptions: GetSubscriptions200SubscriptionsItem[];
  /** 전체 구독 수 */
  totalCount: number;
};
